import { createSlice, PayloadAction } from "@reduxjs/toolkit"

interface IinitialState {
    isToolTip: boolean,
    toolTipContent: string
    isUseItemOptionsView: boolean
    chosenSkillIndex: number | null
}

const initialState: IinitialState = {
    isToolTip: false,
    toolTipContent: "stats",
    isUseItemOptionsView: false,
    chosenSkillIndex: null
}

export const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        setIsToolTip(state, action: PayloadAction<boolean>) {
            state.isToolTip = action.payload
        },
        setToolTipContent(state, action: PayloadAction<string>) {
            state.toolTipContent = action.payload
        },
        setIsUseItemOptionsView(state, action: PayloadAction<boolean>) {
            state.isUseItemOptionsView = action.payload
        },
        setChosenSkillIndex(state, action: PayloadAction<number | null>) {
            state.chosenSkillIndex = action.payload
        }
    }
})

export default uiSlice.reducer